import { makeObservable, observable } from 'mobx'
import * as R from 'ramda'

class Store {
    @observable templateId

    questionMap = {}

    pageQuestions = []

    parentQuestions = []

    template

    constructor() {
        makeObservable(this)
    }

    init = (templateCreationPageId, survey, appStore) => {
        let addPage = true
        const pages = survey.pages.reduce((arr, page) => {
            if (addPage) {
                arr.push(page)
            }

            if (page.id === templateCreationPageId) {
                addPage = false
            }

            return arr
        }, [])

        const toOption = ({ question }) => ({
            value: question.id,
            label: question.content.getTitleByLocale('shortTitle', appStore.surveyLocale, survey.metadata.defaultLocale),
        })

        this.page = pages.pop()
        const currentPageQuestions = R.pathOr([], ['questions'], this.page)
        const previousPageQuestions = pages
            .reduce((arr, { questions }) => {
                arr.push(...R.or(questions, []))
                return arr
            }, [])

        const questionMap = [...previousPageQuestions, ...currentPageQuestions]
            .reduce((map, { question }) => (
                Object.assign(map, { [question.id]: question })
            ), {})

        this.questionMap = questionMap
        this.pageQuestions = currentPageQuestions.map(toOption)
        this.parentQuestions = previousPageQuestions.map(toOption)

        this.selectedLocale = appStore.surveyLocale
        this.surveyLocale = survey.metadata.defaultLocale

        this.initTemplate(this.page)
    }

    initTemplate = ({ template }) => {
        try {
            this.template = JSON.parse(template)
            this.templateId = this.template.id
        } catch (e) {}
    }

    changeTempalate = ({ value }) => {
        if (!value) {
            this.templateId = undefined
            this.teplate = undefined
            this.onSave = undefined
        } else {
            this.templateId = value
        }
    }

    save = (appStore, onClose) => {
        try {
            if (typeof this.onSave === 'function') {
                const body = this.onSave()
                this.page.template = JSON.stringify(body)
            } else {
                this.page.template = undefined
            }

            this.page.update(appStore, appStore.survey)
            onClose()
        } catch (e) {
            console.error(e)
            appStore.handleError({
                body: 'Error creating template. Check that all fields are populated',
                level: 'error',
            })
        }
    }
}

export default Store
